export default "__VITE_ASSET__367b0716__"